<template lang="html">
  <div v-if="visible" class="addtodo" :class="{dark: darkmode}" @click="$emit('click', $event)">
    <AveBigIcon :icon="iconAdd" :class="{dark: darkmode}"/>
    <section class="description">
      <h3 class="addTaskHead">{{title}}</h3>
      <p class="addText">{{description}}</p>
      <p class="addText">{{labels}}</p>
    </section>
  </div>
</template>

<script>
import AveBigIcon from '@/components/AveBigIcon.vue';

export default {
  data() {
    return {
      iconAdd: 'addProject',
      title: 'Add Task, To Do,...',
      description: 'Estimated time, Date',
      labels: '#Label1  #Label2  #Label3',
    };
  },
  components: {
    AveBigIcon,
  },
  props: {
    darkmode: Boolean,
    errorType: String,
    visible: Boolean,
  },
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'
h3
  &.addTaskHead
    margin: 0
    margin-bottom: 3px

p
  margin 0

  &.addText
    margin: 0
    font-size: 11px
    font-weight: 600
    line-height: 152.8%

.addtodo
  left -10px
  width $contentWrapperWidth
  margin auto
  position relative
  display flex
  align-items: center
  background-color: $white
  margin-bottom $marginBottom + 12px

  :hover
    cursor: pointer

  &.dark
    background-color: $normal
    color $darkmodeWhite

.bigicon
  margin-right: 13px
  margin-left: 10px
</style>
